import _ from "underts";
const getPlageFromHM = (HM, bornes) => {
    return _.first(bornes.filter((plage) => plage.start.hour * 60 + plage.start.minute <=
        HM.hour * 60 + HM.minute &&
        plage.end.hour * 60 + plage.end.minute >= HM.hour * 60 + HM.minute));
};
export default getPlageFromHM;
//# sourceMappingURL=getPlageFromHM.js.map